<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="secondary"
        v-on="on"
        v-bind="attrs"
        rounded
        class="white--text ml-2"
        small
      >
        <v-icon size="17" class="mr-2">mdi-help-circle-outline</v-icon>
        Orientações</v-btn
      >
    </template>
    <v-list>
      <v-list-item
        link
        v-for="(ajuda, i) in ajudas"
        :key="i"
        @click="openModalAjuda(ajuda)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ ajuda.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data: () => ({
    ajudas: [
      {
        title: "Salário Família",
        funcao: "ajudasalariofamilia",
        tituloModal: "Orientações Salário Família",
      },
      {
        title: "Imposto de Renda",
        funcao: "ajudaimpostorenda",
        tituloModal: "Orientações Imposto de Renda",
      },
    ],
  }),
  methods: {
    ...mapMutations("dependentes", ["setModalAjuda", "setAjudaSelecionada"]),
    openModalAjuda(ajuda) {
      this.setAjudaSelecionada(ajuda);
      this.setModalAjuda(true);
    },
  },
};
</script>

<style>
</style>